.card {
  cursor: pointer;
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--tuna-palette-background-default);
  border-radius: var(--tuna-shape-borderRadius);
}

@media (prefers-reduced-motion: no-preference) {
  .card {
    transition:
      background-color 0.2s,
      opacity 0.2s;
  }
}

.card:hover {
  background-color: var(--tuna-palette-action-hover) !important;
  border-radius: var(--tuna-shape-borderRadius);
}

.hasImage:hover {
  opacity: 0.7;
}

.backgroundImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.headerOverlay {
  background-color: rgba(var(--tuna-palette-background-paper-channel), 0.8);
  z-index: 1;
}

.headerContent {
  flex: 1;
  overflow: hidden;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mediaContent {
  flex: 1;
  cursor: pointer;
  max-height: 300px;
  padding: 16px;
}

.mediaContentOverlay {
  z-index: 1;
  background-color: rgba(var(--tuna-palette-background-paper-channel), 0.8);
}

.dropHover {
  border-color: var(--tuna-palette-success-main);
  border-width: 8px;
  border-style: dashed;
}

.actions {
  display: flex;
  align-items: center;
  padding: 8px;
}

.headerActions {
  align-items: center;
  padding-left: 8px;
}

/* The card's "more" action stays visible at low opacity so it is reachable
 * by touch and visible to screen readers; it lifts to full opacity when the
 * card is hovered or the button itself receives keyboard focus. The previous
 * opacity:0-on-hover-only pattern hid the action entirely on touch and from
 * keyboard users until first interaction. */
.menuButton {
  cursor: pointer;
  opacity: 0.4;
}

@media (prefers-reduced-motion: no-preference) {
  .menuButton {
    transition: opacity 0.2s;
  }
}

.card:hover .menuButton,
.menuButton:hover,
.menuButton:focus-visible {
  opacity: 1;
}

.lastEditorSlot {
  position: absolute;
  right: 8px;
  bottom: 8px;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .lastEditorSlot {
    transition: opacity 120ms ease-out;
  }
}

/* Recently-updated grid cards surface a muted "which space" chip as inline
 * metadata text (not a pill — no border, no background). The space name
 * truncates with ellipsis so a long space name never pushes the relative time
 * off the card; the time itself sits outside this class and never truncates. */
.parentSpace {
  color: var(--tuna-palette-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60%;
  vertical-align: bottom;
}

/* Secondary metadata line on grid cards: optional parent-space chip, a middot,
 * then the relative time. The line is a flex row so the space chip can truncate
 * (it owns the ellipsis via .parentSpace) while the time stays whole. */
.secondaryLine {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

/* The relative time must never truncate — it shrinks last and keeps its glyphs. */
.secondaryTime {
  flex: 0 0 auto;
  white-space: nowrap;
}
